@if (bestAvailable) {
  @if (bestAvailable.price.discount.percentage >= 5) {
    <mb-advice align="right" color="success" class="gift">
      {{ bestAvailable.price.discount.percentage | number: '1.0-0' }}% OFF
    </mb-advice>
  }

  @if (!isAlliance) {
    <am-price
      [showAmountTotal]="priceByValue === 'TOTAL'"
      [rateSelected]="bestAvailable"
      [fop]="bestAvailable.payment_method.code"
      [quantityNights]="quantityNights"
      [guests]="quantityGuests"
      [quantityRooms]="quantityRooms"
      [isArgentinian]="isArgentinian"
    ></am-price>
  }
  <button mb-button variant="principal" color="primary" (click)="trackShowRooms()">
    {{ btnLabel }}
  </button>
} @else {
  @if (!isLanding) {
    @if (selectedPaymentMethod === 'all') {
      <div
        class="alert-description"
        i18n="@@bestroompricebox_uy_no_hay_disponibilidad_podes_probar_otras_fechas"
      >
        Uy, no hay disponibilidad. Podés probar otras fechas.
      </div>
    } @else {
      @if (selectedPaymentMethod === 'PREPAID') {
        <div
          class="alert-description"
          i18n="@@uy_no_hay_disponibilidad_podes_pagando_en_cuotas_proba_con_otro_metodo_de_pago_o_en_otra_fecha"
        >
          Uy, no hay disponibilidad pagando en cuotas. Probá con otro método de pago o en
          otra fecha.
        </div>
      }
      @if (selectedPaymentMethod === 'PAY_AT_DESTINATION') {
        <div
          class="alert-description"
          i18n="@@uy_no_hay_disponibilidad_podes_pagando_en_destino_proba_con_otro_metodo_de_pago_o_en_otra_fecha"
        >
          Uy, no hay disponibilidad pagando en destino. Probá con otro método de pago o en
          otra fecha.
        </div>
      }
    }
    <search-widget
      id="more-rooms"
      [searchedEntity]="searchedEntity"
      [section]="'detail'"
      (resetState)="onResetState()"
      [isDisney]="isDisney"
      [buttonMode]="true"
      [modify]="true"
    >
    </search-widget>
  } @else {
    <div
      class="alert-description"
      i18n="@@bestroompricebox_ingresa_las_fechas_de_tu_estadia_para_ver_los_precios_de_las_habitaciones"
    >
      <strong>Ingresa las fechas</strong> de tu estadía para ver los precios de las
      habitaciones
    </div>
    <search-widget
      [searchedEntity]="searchedEntity"
      [section]="'detail'"
      (resetState)="onResetState()"
      [isDisney]="isDisney"
      [buttonMode]="true"
    >
    </search-widget>
  }
}
